import d from 'lodash/debounce';

export function debounce(milliseconds = 500): MethodDecorator {
  return function (_target: unknown, _propertyKey: string, descriptor: PropertyDescriptor) {
    const original = descriptor.value;
    descriptor.value = d(original, milliseconds);
    return descriptor;
  };
}
